import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type {
  ProfitabilitySummaryBreakdownQuery,
  ProfitabilitySummaryShippingCostsResponse,
} from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

export const useProfitabilitySummaryShippingCosts = (
  query: ProfitabilitySummaryBreakdownQuery | undefined,
  enabled = true,
) => {
  return useQuery<ProfitabilitySummaryShippingCostsResponse, Error>({
    queryKey: [
      'profitability',
      'summary-shipping-costs',
      query?.start_date,
      query?.end_date,
      query?.date_column,
      query?.shop_id,
      query?.payment_method_id,
      query?.shipment_status_id,
      query?.page,
      query?.per_page,
    ],
    queryFn: () => adapter.getSummaryShippingCosts(query),
    enabled: enabled && !!query?.start_date && !!query?.end_date,
    staleTime: 60 * 1000,
  });
};
